<div class="credit-app-container" [ngClass]="{'h-100': !isBuyNow && !isLegacyCreditApp}">
<div class="stepper-component" style="position: relative">
    <ngx-ui-loader [loaderId]="'creditApplication'" [ngClass]= "{'isBackButton': hasbackButton, 'noBackButton': !hasbackButton}"></ngx-ui-loader>
    <dt-unlock [hidden]="isUnlocked" (unlocked)="unlocked($event)"></dt-unlock>
    <dt-status-bar [componants]="components" [activeIndex]="activeIndex" *ngIf="isUnlocked && confirmation && activeIndex < 13"></dt-status-bar>
    <div [hidden]="!isUnlocked"  [ngClass]="{'main-body': !isBuyNow && !isLegacyCreditApp, 'buynow-creditapp-body': isBuyNow || isLegacyCreditApp, 'legacycreditapp-marginTop': isLegacyCreditApp,'pt-0': (isBuyNow || isLegacyCreditApp) && activeIndex > 12 && flagForBuyNowConfirmation}">
        <ng-template dtComponenthost></ng-template>
    </div>
    <div class="jacked" [ngClass]="{'jacked-buyNow': isBuyNow,'jacked-legacyCA': isLegacyCreditApp && isLeadRoutingFlag}" *ngIf="stepnotSaved">
        <div class="jacked-body row">
            <span class="jacked-image"><img [src]="jackedData?.JackedImage"></span>
            <span class="jacked-title"> {{jackedData?.JackedTitle}}</span>
            <span class="jacked-subtitle"> {{jackedData?.JackedMessage}}</span>
            <span class="jacked-cta"><button (click)="closeJacked()" class="secondary-cta"> {{jackedData?.JackedCTA}}</button></span>
        </div>
    </div>
</div>
</div>
